import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface UseOfAuditorsSpecialistRommsProps {
  onBack: () => void;
}

export default function UseOfAuditorsSpecialistRomms({ onBack }: UseOfAuditorsSpecialistRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Use of Auditor Specialist" />;
}
